export const SET_FORM_FIELD_VALUE = 'SET_FORM_FIELD_VALUE'

export const setFormFieldValues = (formName, fieldId, fieldVal) => ({
  type: SET_FORM_FIELD_VALUE,
  data: { formName, fieldId, fieldVal }
})
